import type { ReactNode } from 'react';
import React from 'react';

import * as styles from '../styles/DrawerContainer.styles';

export interface DrawerContainerProps {
  children: ReactNode;
}

export const DrawerContainer = ({ children }: DrawerContainerProps) => (
  <div css={styles.container}>{children}</div>
);
